export const RACK_TYPE_META = Object.freeze({
  gpu: Object.freeze({
    id: 'gpu',
    label: 'GB300 / NVL72 GPU',
    shortLabel: 'NVL72',
    color: '#22c55e',
    accent: '#86efac',
    cabinet: 'NVIDIA GB300 / NVL72 integrated rack',
    elevationSource: 'Panduit design - NVL72 cabinet / structured cabling',
    equipment: Object.freeze([
      Object.freeze({ role: 'GB300 / NVL72 compute system', productId: 'GB300 / NVL72', note: '72 GPU project rack; active BOM defines 66 racks / 4,752 GPUs.' }),
      Object.freeze({ role: 'GPU fabric optics', productId: '980-9IAT0-00XM00', model: 'MMS4A20-XM800', note: '800G OSFP DR4 transceiver used on B300.' }),
      Object.freeze({ role: 'In-rack / structured fiber', productId: 'FAPH1812BLMPO', note: '18-port MPO adapter panel from Panduit materials list.' }),
      Object.freeze({ role: 'Fiber patch panel', productId: 'CFAPPMBL1', note: 'Opticom fiber patch panel.' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'Top-of-rack MPO / fiber', size: 5 }),
      Object.freeze({ label: 'GPU fabric connections', size: 7 }),
      Object.freeze({ label: 'GB300 / NVL72 compute trays', size: 24 }),
      Object.freeze({ label: 'OOB / management', size: 5 }),
      Object.freeze({ label: 'Power / rack base', size: 7 }),
    ]),
  }),

  leaf: Object.freeze({
    id: 'leaf', label: 'Leaf Rack', shortLabel: 'LEAF', color: '#0ea5e9', accent: '#7dd3fc',
    cabinet: '48RU network cabinet (Panduit optional cabinet basis: 800 x 1200)',
    elevationSource: 'Data Hall 1 rack elevation + Panduit Leaf section',
    equipment: Object.freeze([
      Object.freeze({ role: 'Compute Leaf - Q3400-RA', productId: '920-9B36F-00RX-8S0', model: 'Q3400-RA', note: 'Quantum-3 XDR InfiniBand; BOM role: Compute Leaf.' }),
      Object.freeze({ role: 'B300 Ethernet Leaf - SN5610', productId: '920-9N42F-00RI-3C1', model: 'SN5610', note: 'Spectrum-4 800GbE; BOM role: B300 Leaf Switches.' }),
      Object.freeze({ role: 'MPO adapter panel', productId: 'FAPH1612BLMPO', note: '16 MPO panel used in leaf rack design.' }),
      Object.freeze({ role: 'Copper patch panel', productId: 'CPP24FMWBLY', note: '24-port patch panel.' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'OOB control / management', size: 4 }),
      Object.freeze({ label: 'N/S compute + N/S leaf', size: 9 }),
      Object.freeze({ label: 'E/W leaf fabric switches', size: 20 }),
      Object.freeze({ label: 'E/W spine patching', size: 8 }),
      Object.freeze({ label: 'Copper / fiber management', size: 7 }),
    ]),
  }),

  spareLeaf: Object.freeze({
    id: 'spareLeaf', label: 'Spare Leaf Rack', shortLabel: 'SPARE LEAF', color: '#eab308', accent: '#fde047',
    cabinet: '48RU network cabinet',
    elevationSource: 'Panduit spare Leaf rack materials section',
    equipment: Object.freeze([
      Object.freeze({ role: 'Spare leaf infrastructure', productId: '920-9B36F-00RX-8S0', model: 'Q3400-RA', note: 'Spare leaf rack follows the leaf archetype; exact active switch population is a project spare.' }),
      Object.freeze({ role: 'Fiber patch panel', productId: 'CFAPPMBL1' }),
      Object.freeze({ role: 'MPO panels', productId: 'FAPH1612BLMPO / FAPH1812BLMPO' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'Reserved / spare switching', size: 14 }),
      Object.freeze({ label: 'Fiber patching', size: 18 }),
      Object.freeze({ label: 'Copper patching', size: 8 }),
      Object.freeze({ label: 'Reserved RU', size: 8 }),
    ]),
  }),

  spine: Object.freeze({
    id: 'spine', label: 'Spine Rack', shortLabel: 'SPINE', color: '#8b5cf6', accent: '#c4b5fd',
    cabinet: '48RU network cabinet (Panduit optional cabinet basis: 800 x 1200)',
    elevationSource: 'Panduit Spine rack structured-cabling section',
    equipment: Object.freeze([
      Object.freeze({ role: 'Compute Spine - Q3400-RA', productId: '920-9B36F-00RX-8S0', model: 'Q3400-RA', note: 'BOM role: Compute Spine.' }),
      Object.freeze({ role: 'MPO enclosure', productId: 'FRE4UBL', note: '4RU Opticom fiber enclosure.' }),
      Object.freeze({ role: 'MPO adapter panel', productId: 'FAPH1612BLMPO' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'DH1 / DH2 leaf inputs', size: 12 }),
      Object.freeze({ label: 'Compute spine fabric', size: 22 }),
      Object.freeze({ label: 'Hot-spare patching', size: 7 }),
      Object.freeze({ label: 'Fiber / copper management', size: 7 }),
    ]),
  }),

  oob: Object.freeze({
    id: 'oob', label: 'N/S OOB Rack', shortLabel: 'OOB', color: '#ef4444', accent: '#fca5a5',
    cabinet: '48RU network cabinet',
    elevationSource: 'Data Hall 1 OOB spine rack elevation + Panduit OOB section',
    equipment: Object.freeze([
      Object.freeze({ role: 'OOB management leaf', productId: '920-9N110-00R1-0C0', model: 'SN2201', note: 'Spectrum 1GBase-T / 100GbE management switch.' }),
      Object.freeze({ role: 'OOB Spine', productId: '920-9N42F-00RI-3C1', model: 'SN5610', note: 'BOM role: OOB Spines.' }),
      Object.freeze({ role: '100G OOB optic', productId: '980-9I042-00C000', model: 'MMS1V70-CM' }),
      Object.freeze({ role: 'Fiber enclosure', productId: 'FRE4UBL / FRE2UBL' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'DH1 / DH2 OOB aggregation', size: 10 }),
      Object.freeze({ label: 'OOB spine switching', size: 11 }),
      Object.freeze({ label: 'N/S / border / storage paths', size: 15 }),
      Object.freeze({ label: 'Fiber + copper patching', size: 12 }),
    ]),
  }),

  control: Object.freeze({
    id: 'control', label: 'Control Rack', shortLabel: 'CONTROL', color: '#f43f5e', accent: '#fda4af',
    cabinet: '48RU network cabinet',
    elevationSource: 'Data Hall 1 Control rack elevation + Panduit Control section',
    equipment: Object.freeze([
      Object.freeze({ role: 'Control Leaf - SN5610', productId: '920-9N42F-00RI-3C1', model: 'SN5610', note: 'BOM role: Control Leaf Switches.' }),
      Object.freeze({ role: 'OOB management - SN2201', productId: '920-9N110-00R1-0C0', model: 'SN2201', note: 'Management/OOB switch family used by network racks.' }),
      Object.freeze({ role: 'UFM Appliance 3.5', productId: '920-9B020-00RI-0D0', model: 'MUA9702H-2SFS', note: 'Two appliances in project; Panduit notes UFM is only in Row 1 and Row 2 control.' }),
      Object.freeze({ role: 'MPO adapter panel', productId: 'FAPH1612BLMPO' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'OOB N/S spine / UFM leaf', size: 8 }),
      Object.freeze({ label: 'OOB management leaf', size: 8 }),
      Object.freeze({ label: 'N/S control leaf', size: 8 }),
      Object.freeze({ label: 'Control / UFM services', size: 10 }),
      Object.freeze({ label: 'Reserved RU', size: 14 }),
    ]),
  }),

  storage: Object.freeze({
    id: 'storage', label: 'DH2 Storage Rack', shortLabel: 'STORAGE', color: '#f97316', accent: '#fdba74',
    cabinet: '48RU storage / network cabinet',
    elevationSource: 'Panduit Storage cabinet archetype + storage structured-cabling section',
    equipment: Object.freeze([
      Object.freeze({ role: 'Storage nodes', productId: 'Customer Provided', note: 'Active BOM defines 136 storage nodes project-wide.' }),
      Object.freeze({ role: 'Storage Leaf - SN5610', productId: '920-9N42F-00RI-3C1', model: 'SN5610', note: 'BOM role: Storage leaf switch.' }),
      Object.freeze({ role: 'MPO adapter panel', productId: 'FAPH1612BLMPO' }),
      Object.freeze({ role: 'Copper patch panel', productId: 'CPP24FMWBLY' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'Storage fabric / patching', size: 10 }),
      Object.freeze({ label: 'Storage nodes', size: 27 }),
      Object.freeze({ label: 'Copper / OOB management', size: 6 }),
      Object.freeze({ label: 'Rack base', size: 5 }),
    ]),
  }),

  storageOob: Object.freeze({
    id: 'storageOob', label: 'DH2 Storage OOB Rack', shortLabel: 'STORAGE OOB', color: '#f59e0b', accent: '#fcd34d',
    cabinet: '48RU network cabinet',
    elevationSource: 'Panduit Storage + OOB structured-cabling sections',
    equipment: Object.freeze([
      Object.freeze({ role: 'Storage OOB management - SN2201 family', productId: '920-9N110-00R1-0C0', model: 'SN2201', note: 'BOM role: OOB SN2201s for Network and Storage Racks.' }),
      Object.freeze({ role: '100G OOB optic', productId: '980-9I042-00C000', model: 'MMS1V70-CM' }),
      Object.freeze({ role: 'Fiber patch panel', productId: 'CFAPPMBL1' }),
      Object.freeze({ role: 'MPO adapter panel', productId: 'FAPH1612BLMPO' }),
    ]),
    elevation: Object.freeze([
      Object.freeze({ label: 'Storage OOB uplinks', size: 9 }),
      Object.freeze({ label: 'OOB switching', size: 10 }),
      Object.freeze({ label: 'Fiber patching', size: 12 }),
      Object.freeze({ label: 'Copper management', size: 8 }),
      Object.freeze({ label: 'Reserved RU', size: 9 }),
    ]),
  }),
});

const repeat = (type, count) => Array.from({ length: count }, () => type);

// Level 1: 54 deployed racks across 57 architectural cabinet positions.
// The 7/7/8/6/6/6/7/7 P2P population is visible in the supplied Halls 1&2 P2P layout.
// Hall 102 drawing shows three additional architectural positions; these remain visible as empty slots.
export const LEVEL1_ROWS = Object.freeze([
  Object.freeze({ row: 1, letter: 'A', architectureFqns: ['A14','A12','A10','A08','A06','A04','A02'], types: [...repeat('gpu',4),'leaf','oob','control'] }),
  Object.freeze({ row: 2, letter: 'B', architectureFqns: ['B13','B11','B09','B07','B05','B03','B01'], types: [...repeat('gpu',4),'leaf','spine','control'] }),
  Object.freeze({ row: 3, letter: 'C', architectureFqns: ['C14','C12','C10','C08','C06','C05','C04','C02'], types: [...repeat('gpu',5),'leaf','spine','spareLeaf'] }),
  Object.freeze({ row: 4, letter: 'D', architectureFqns: ['D13','D11','D09','D07','D05','D03','D01'], types: [...repeat('gpu',4),'leaf','spine'], emptyFqns: ['D01'] }),
  Object.freeze({ row: 5, letter: 'E', architectureFqns: ['E14','E12','E10','E08','E06','E04','E02'], types: [...repeat('gpu',4),'leaf','spine'], emptyFqns: ['E02'] }),
  Object.freeze({ row: 6, letter: 'F', architectureFqns: ['F13','F11','F09','F07','F05','F03','F01'], types: [...repeat('gpu',4),'leaf','spine'], emptyFqns: ['F01'] }),
  Object.freeze({ row: 7, letter: 'G', architectureFqns: ['G14','G12','G10','G08','G06','G04','G02'], types: [...repeat('gpu',4),'leaf','oob','control'] }),
  Object.freeze({ row: 8, letter: 'H', architectureFqns: ['H13','H11','H09','H07','H05','H03','H01'], types: [...repeat('gpu',4),'leaf','spine','control'] }),
]);

// Level 2: 57 deployed racks. Panduit explicitly places one Storage rack and one Storage-OOB rack in each Row 1-8.
// The project has 16 Leaf racks total, giving one Leaf rack per row in each hall. The remaining 33 positions are NVL72 GPU racks.
export const LEVEL2_ROWS = Object.freeze([
  Object.freeze({ row: 1, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 2, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 3, types: [...repeat('gpu',5),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 4, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 5, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 6, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 7, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
  Object.freeze({ row: 8, types: [...repeat('gpu',4),'leaf','storageOob','storage'] }),
]);

function countsFor(rows) {
  const counts = {};
  rows.forEach((row) => row.types.forEach((type) => { counts[type] = (counts[type] || 0) + 1; }));
  return Object.freeze(counts);
}

export const SHARON_RACK_COUNTS = Object.freeze({
  level1: Object.freeze({ total: LEVEL1_ROWS.reduce((sum, row) => sum + row.types.length, 0), ...countsFor(LEVEL1_ROWS) }),
  level2: Object.freeze({ total: LEVEL2_ROWS.reduce((sum, row) => sum + row.types.length, 0), ...countsFor(LEVEL2_ROWS) }),
  project: Object.freeze({ total: 111, gpu: 66, leaf: 16, spareLeaf: 1, spine: 6, oob: 2, control: 4, storage: 8, storageOob: 8 }),
});

export function buildLevelRacks(levelId) {
  const rows = levelId === 'level1' ? LEVEL1_ROWS : LEVEL2_ROWS;
  const hall = levelId === 'level1' ? 'Data Hall 102' : 'Data Hall 202';
  const podCenters = [-27, -9, 9, 27];
  const rowXs = podCenters.flatMap((center) => [center - 2.15, center + 2.15]);
  const centerZ = 9;
  const spacing = 3.0;

  return rows.flatMap((rowDef, rowIndex) => {
    const archCount = rowDef.architectureFqns?.length || rowDef.types.length;
    const start = centerZ - ((archCount - 1) * spacing) / 2;
    const typeQueue = [...rowDef.types];
    const emptySet = new Set(rowDef.emptyFqns || []);

    return Array.from({ length: archCount }, (_, slotIndex) => {
      const architecturalFqn = rowDef.architectureFqns?.[slotIndex] || null;
      const isEmpty = architecturalFqn && emptySet.has(architecturalFqn);
      const type = isEmpty ? 'empty' : typeQueue.shift();
      const p2pPosition = isEmpty ? null : rowDef.types.length - typeQueue.length;

      return Object.freeze({
        id: levelId === 'level1'
          ? `S6-102-${architecturalFqn}`
          : `S6-202-R${rowDef.row}-${String(p2pPosition).padStart(2,'0')}`,
        level: levelId,
        hall,
        row: rowDef.row,
        rowLetter: rowDef.letter || null,
        architecturalFqn,
        p2pPosition,
        type,
        occupied: type !== 'empty',
        x: rowXs[rowIndex],
        z: start + slotIndex * spacing,
        rotation: 0,
        mappingBasis: levelId === 'level1'
          ? 'Hall 102 architectural FQN + P2P row population + Panduit rack breakdown'
          : 'DH2 row-level Panduit storage/OOB allocation + project rack totals',
      });
    });
  });
}

export const LEVEL1_RACKS = Object.freeze(buildLevelRacks('level1'));
export const LEVEL2_RACKS = Object.freeze(buildLevelRacks('level2'));
